import React from 'react';
import { reduce } from 'lodash';
import { FormField } from 'taboola-ultimate-ui';
import { useConfigMatch, useAccountConfig } from 'modules/taboola-common-frontend-modules/account-configurations';
import { ExternalMetadata } from 'modules/taboola-common-frontend-modules/externalMetadata/components/ExternalMetadata/ExternalMetadata';
import { useExternalMetadataAvailableKeys } from 'modules/taboola-common-frontend-modules/externalMetadata/hooks/useExternalMetadataAvailableKeys';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import styles from '../commonEditor.module.scss';

export const ExternalMetadataWrapper = ({
    externalDataDeletionDisabled,
    externalDataReadOnlyFields,
    externalMetadataKeyOptions,
    msgIdPrefix,
}) => {
    const isRemovable = useConfigMatch({
        [externalDataDeletionDisabled]: 'false',
    });

    const { [externalDataReadOnlyFields]: readonlyFields } = useAccountConfig([externalDataReadOnlyFields]);

    const options = useExternalMetadataAvailableKeys(externalMetadataKeyOptions);

    const externalMetadataKeyLabels = reduce(
        externalMetadataKeyOptions,
        (acc, { value, label }) => ({ ...acc, [value]: label }),
        {}
    );

    return (
        <FormField
            inputId="external-metadata"
            containerClass={styles['input']}
            label={<FormattedMessage id="externalMetadata.editor" defaultMessage="External Metadata" />}
        >
            <ExternalMetadata
                isRemovable={isRemovable}
                readonlyFields={readonlyFields}
                options={options}
                externalMetadataKeyLabels={externalMetadataKeyLabels}
                msgIdPrefix={msgIdPrefix}
            />
        </FormField>
    );
};
